import { useToastContext } from '../contexts/ToastContext';
import type { ToastVariant } from '../contexts/ToastContext';

interface ToastOptions {
  title: string;
  description?: string;
  variant?: ToastVariant;
  duration?: number;
}

export function useToast() {
  const { addToast } = useToastContext();

  const toast = ({ title, description, variant = 'info', duration }: ToastOptions) => {
    addToast({
      title,
      description,
      variant,
      duration: duration ?? (variant === 'error' ? 7000 : 5000),
    });
  };

  return { toast };
}

// Kept for backward-compatibility with existing tests that import this symbol
export function __setToastCallback(_cb: unknown): void {
  // no-op: implementation now uses ToastContext
}
